const STRINGS = {
  "common.back": "Back",
  "epics.tags": "Tags",
  "epics.title": "Epics",
  "goals.empty_list.message": "No goals have been set yet",
  "goals.title": "Goals",
  "milestones.empty_list.message": "No milestones have been set yet",
  "milestones.title": "Milestones",
  "products.budget.title": "Budget",
  "products.market_research_empty": "No market research has been done yet",
  "products.market_research.title": "Market research",
  "products.title": "Products"
};

export default STRINGS;